<div class="main-container">
    <ng-container [ngTemplateOutlet]="selectTime" [ngTemplateOutletContext]="hours"></ng-container>
    <span>:</span>
    <ng-container [ngTemplateOutlet]="selectTime" [ngTemplateOutletContext]="minutes"></ng-container>
    <span>:</span>
    <ng-container [ngTemplateOutlet]="selectTime" [ngTemplateOutletContext]="seconds"></ng-container>
    <ng-container [ngTemplateOutlet]="selectTime" [ngTemplateOutletContext]="formatosDeHora"></ng-container>
</div>

<ng-template #selectTime let-options="options" let-templateId="templateId">
    <div class="time-select-container">
        <div class="time-display">
            <input
                #timeInput
                [value]="timeValue[templateId]"
                type="text" [readOnly]="templateId === formatosDeHora.templateId"
                (input)="validateInput($event, options.length, templateId)">
            <button (click)="toggleOptions(optionsContainer)">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="https://www.w3.org/2000/svg">
                    <path d="M12 6.40002L8 10.4L4 6.40002" stroke="#2B2D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
        <div class="options"  #optionsContainer [id]="templateId">
            @for (item of options; track $index) {
                <button (click)="setOptionSelected(timeInput, item, templateId); toggleOptions(optionsContainer)">{{item}}</button>
            }
        </div>
    </div>
</ng-template>

